// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","368":"component---src-pages-verify-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"89c65a41500e5a5ea329","368":"79aa39281fed7d63bbce","453":"1af27739af3cf12c9563","777":"28ac619063c58cee4a97"}[chunkId] + ".js";
};